// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/transponder-phraseology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/transponder-phraseology/transponder-phraseology.js';

mount([g0]);
